import { FeatherIcons, H4, LI, UL } from "../../../../AbstractElements";
import { totalUsersData } from "../../../../Data/Widgets/GeneralWidgetsData";

const TotalUsersBody = () => {
  return (
    <UL className="user-list flex-row simple-list">
      {totalUsersData.map((data,i)=>(
        <LI key={i}>
            <div className={`user-icon ${data.color}`}>
                <div className="user-box">
                  <FeatherIcons className="font-primary" iconName={data.fIcon} />
                </div>
            </div>
            <div>
                <H4 className="mb-1">{data.count}</H4>
                <span className={`font-${data.fontcolor} d-flex align-items-center`}>
                    <i className={`${data.icon} icon-rotate me-1`}> </i>
                    <span className="f-w-500">{data.result}</span>
                </span>
            </div>
        </LI>
      ))}
    </UL>
  );
};

export default TotalUsersBody;
